import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
};

const deleteRecruitmentRequirementSlice = createSlice({
  name: "deleteRecruitmentRequirement",
  initialState,
  reducers: {
    deleteRecruitmentRequirementStart: (
      state,
      action: PayloadAction<{ id: string }>
    ) => {
      state.status = ReduxStateType.LOADING;
    },
    deleteRecruitmentRequirementSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    deleteRecruitmentRequirementFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  deleteRecruitmentRequirementStart,
  deleteRecruitmentRequirementSuccess,
  deleteRecruitmentRequirementFailed,
} = deleteRecruitmentRequirementSlice.actions;

export default deleteRecruitmentRequirementSlice.reducer;
